var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadAutomation2P = function SvgFadAutomation2P(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(48 144)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 32,
    cy: 32,
    r: 16
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144 48)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 32,
    cy: 32,
    r: 16
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M95.17 148.875 149.64 94l10.72 11.943L104.911 161z"
  }))));
};
export { SvgFadAutomation2P as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-automation-2p.952fccef.svg";